import { useEffect } from "react";
import { TOASTIFY_CONTAINER_ID } from "constants/toastify";
import { MODAL_ID } from "constants/settings";

export const useOnClickOutside = (ref, handler) => {
    useEffect(() => {
        const listener = (event) => {
            if (
                !ref.current ||
                ref.current.contains(event.target) ||
                Boolean(event.target.closest(`#${TOASTIFY_CONTAINER_ID}`)) ||
                Boolean(event.target.closest(`#${MODAL_ID}`))
            ) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);

        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [ref, handler]);
};
